// Styles
import "./dashboard.scss";
// Tools
import { useMemo } from "react";
// Components
import { Accounts } from "./components/accounts/Accounts";
import { Campaigns } from "./components/campaigns/Campaigns";
import { Apps } from "./components/apps/Apps";
// Utils
import { SplitPane } from "../../utils/split-pane/splitPane";
// Store
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../shared/store/store";
// Utils
import filterModules from "../../utils/module-utils/filter-modules-by-section";
import { getModulesWeights } from "../../utils/module-utils/get-modules-weights";
import { getModulesFromStorage } from "../../utils/module-utils/get-modules-from-storage";

export const Dashboard = () => {
	// Все окна категории Dashboard
	const allPanes = [
		<Accounts key='accounts' />,
		<Campaigns key='campaigns' />,
		<Apps key='apps' />,
	].filter(Boolean);

	/* 
		Попробуем взять конфиг из localStorage — если его нет или он некорректный,
		используем конфиг из стора (appModulesConfig)
	*/
	const appModulesConfig = useSelector(
		(state: RootState) => state.app.modulesConfig,
	);
	const layoutHardResetNonce = useSelector(
		(state: RootState) => state.app.layoutHardResetNonce,
	);
	const modulesConfigFromStorage = getModulesFromStorage();
	// Сначала берем из localStorage, потом из appModulesConfig
	const modulesConfigToUse = modulesConfigFromStorage ?? appModulesConfig;

	// Актуальные модули
	const panes = filterModules(
		"dashboard", // Название секции
		allPanes, // Все компоненты
		modulesConfigToUse ?? undefined, // Конфигурация (порядок модулей)
	);

	// Сигнатуры для ререндера компонента
	const modSig = JSON.stringify(modulesConfigToUse ?? []);
	const paneKeysSig = panes
		.map((p) => String((p as React.ReactElement)?.key ?? ""))
		.join(",");
	// Расчет процентов ширины
	const initialPercents = useMemo(
		() => getModulesWeights(modulesConfigToUse ?? undefined, panes),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[modSig, paneKeysSig, layoutHardResetNonce],
	);

	// Ключ меняется при изменении состава или порядка панелей.
	// Это заставляет SplitPane перемонтироваться с актуальным порядком после сброса.
	const splitPaneKey = panes
		.map((p) => (p as React.ReactElement)?.key ?? "")
		.join(",");

	return (
		<div className='dashboard'>
			<SplitPane
				key={`${splitPaneKey}-${layoutHardResetNonce}`}
				panes={panes}
				direction='horizontal'
				initialPercents={initialPercents.length ? initialPercents : undefined}
			/>
		</div>
	);
};
